import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSubmenu from '../../components/ServicesSubmenu';
import '../../styles/ServiceDetail.css';

const WebDevelopment: React.FC = () => {
  return (
    <div className="service-detail-page">
      <section className="service-detail-hero">
        <div className="container">
          <h1>Custom Web Development</h1>
          <p>Building Powerful, Scalable Web Solutions for Your Business</p>
        </div>
      </section>

      <ServicesSubmenu />

      <section className="service-overview">
        <div className="container">
          <div className="overview-content">
            <h2>Transform Your Business with Custom Web Solutions</h2>
            <p>At SCL Networks, we specialize in creating tailored web solutions that perfectly align with your business objectives. Our expert development team combines technical expertise with creative problem-solving to deliver robust, scalable, and efficient web applications.</p>
            <div className="key-features">
              <div className="feature-item">
                <i className="fas fa-rocket"></i>
                <h3>Scalable Solutions</h3>
                <p>Build applications that grow with your business</p>
              </div>
              <div className="feature-item">
                <i className="fas fa-shield-alt"></i>
                <h3>Secure Development</h3>
                <p>Implementation of best security practices</p>
              </div>
              <div className="feature-item">
                <i className="fas fa-tachometer-alt"></i>
                <h3>High Performance</h3>
                <p>Optimized for speed and efficiency</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-details">
        <div className="container">
          <div className="details-grid">
            <div className="detail-item">
              <h3>Full-stack Development</h3>
              <ul>
                <li>Front-end development using modern frameworks</li>
                <li>Back-end development with secure APIs</li>
                <li>Database design and optimization</li>
                <li>Cloud integration and deployment</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>Custom CMS Solutions</h3>
              <ul>
                <li>Tailored content management systems</li>
                <li>User-friendly admin interfaces</li>
                <li>Content workflow automation</li>
                <li>Multi-user role management</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>API Development</h3>
              <ul>
                <li>RESTful API design and development</li>
                <li>Third-party API integration</li>
                <li>API documentation and testing</li>
                <li>Performance optimization</li>
              </ul>
            </div>
            <div className="detail-item">
              <h3>Database Solutions</h3>
              <ul>
                <li>Database architecture design</li>
                <li>Performance optimization</li>
                <li>Data migration services</li>
                <li>Backup and recovery solutions</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="development-process">
        <div className="container">
          <h2>Our Development Process</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Requirements Analysis</h3>
              <p>Understanding your business needs and project objectives</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Planning & Design</h3>
              <p>Creating detailed project specifications and architecture</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Development</h3>
              <p>Building your solution using best practices and modern technologies</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Testing & QA</h3>
              <p>Rigorous testing to ensure quality and performance</p>
            </div>
            <div className="step">
              <div className="step-number">5</div>
              <h3>Deployment</h3>
              <p>Smooth deployment and post-launch support</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-maintenance" id="maintenance">
        <h2>Website Maintenance Services</h2>
        <div className="maintenance-grid">
          <div className="maintenance-item">
            <i className="fas fa-sync"></i>
            <h3>Regular Updates</h3>
            <p>Keep your website up-to-date with the latest security patches and feature updates</p>
          </div>
          <div className="maintenance-item">
            <i className="fas fa-shield-alt"></i>
            <h3>Security Monitoring</h3>
            <p>24/7 monitoring and protection against security threats</p>
          </div>
          <div className="maintenance-item">
            <i className="fas fa-tachometer-alt"></i>
            <h3>Performance Optimization</h3>
            <p>Regular performance audits and optimization for faster load times</p>
          </div>
          <div className="maintenance-item">
            <i className="fas fa-life-ring"></i>
            <h3>Technical Support</h3>
            <p>Dedicated support team for quick issue resolution</p>
          </div>
        </div>
      </section>

      <section className="technologies">
        <div className="container">
          <h2>Technologies We Use</h2>
          <div className="tech-stack">
            <div className="tech-category">
              <h3>Frontend</h3>
              <ul>
                <li><i className="fab fa-react"></i> React.js</li>
                <li><i className="fab fa-angular"></i> Angular</li>
                <li><i className="fab fa-vuejs"></i> Vue.js</li>
                <li><i className="fab fa-js"></i> JavaScript</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Backend</h3>
              <ul>
                <li><i className="fab fa-node-js"></i> Node.js</li>
                <li><i className="fab fa-php"></i> PHP/Laravel</li>
                <li><i className="fab fa-python"></i> Python</li>
                <li><i className="fas fa-database"></i> SQL/NoSQL</li>
              </ul>
            </div>
            <div className="tech-category">
              <h3>Tools & Platforms</h3>
              <ul>
                <li><i className="fab fa-aws"></i> AWS</li>
                <li><i className="fab fa-docker"></i> Docker</li>
                <li><i className="fab fa-github"></i> Git</li>
                <li><i className="fas fa-cloud"></i> Cloud Services</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="cta-content">
          <h2>Ready to Start Your Web Development Project?</h2>
          <p>Let's discuss how we can help you achieve your goals</p>
          <Link to="/contact" className="cta-button">Get Started</Link>
        </div>
      </section>
    </div>
  );
};

export default WebDevelopment; 